/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Plan_FreeInputs */

const en_settings_overview_plan_free = /** @type {(inputs: Settings_Overview_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const zh_settings_overview_plan_free = /** @type {(inputs: Settings_Overview_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Settings_Overview_Plan_FreeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_overview_plan_free = /** @type {((inputs?: Settings_Overview_Plan_FreeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Plan_FreeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_overview_plan_free(inputs)
	return zh_settings_overview_plan_free(inputs)
});
export { settings_overview_plan_free as "settings.overview.plan_free" }